/*
 * ******************************************************
 * Copyright (C) 1994-2021 Babiel GmbH <info@babiel.com>
 *
 * This file is part of a Babiel development
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted without the express
 * permission of Babiel GmbH
 *
 * Any modification is not permitted without the express
 * permission of Babiel GmbH
 *
 * The file may contain confidential and or privileged materials.
 * Any review, retransmission, dissemination or other use of
 * or taking of any action in reliance upon, this file
 * by persons or entities other than the intended is prohibited.
 * ******************************************************
 */

import { Registry } from './componentSystem/componentSystem';
import { CareerWidgetComponent } from './components/careerWidgetComponent/careerWidgetComponent';
import { CarouselComponent } from './components/carouselComponent/carouselComponent';
import { ImageGalleryComponent } from './components/imageGalleryComponent/imageGalleryComponent';
import { ContactPersonComponent } from './components/contactPersonComponent/contactPersonComponent';

export const componentRegistration: Registry = {
  careerWidget: (htmlElement: HTMLElement) =>
    new CareerWidgetComponent(htmlElement),
  carousel: async (htmlElement: HTMLElement) =>
    new CarouselComponent(htmlElement),
  imageGallery: (htmlElement: HTMLElement) =>
    new ImageGalleryComponent(htmlElement),
  contactPersons: (htmlElement: HTMLElement) =>
    new ContactPersonComponent(htmlElement),
};
